import { gql } from '@apollo/client';

export const QUERY_ROLE_BY_PAGE = gql`
  query QueryRoleByPage($condition: RoleQueryConditionInput, $pageRequest: PageRequestTypeInput) {
    queryRoleByPage(condition: $condition, pageRequest: $pageRequest) {
      content {
        id
        name
        description
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface RoleType {
  id: number | string;
  name: string;
  description?: string | null;
}

export interface RoleQueryConditionInput {
  id?: number | null;
  name?: string | null;
  description?: string | null;
}

export interface PageRequestTypeInput {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface RolePageResponseType {
  content: RoleType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface QueryRoleByPageResponse {
  queryRoleByPage: RolePageResponseType;
}

export interface QueryRoleByPageVariables {
  condition?: RoleQueryConditionInput | null;
  pageRequest?: PageRequestTypeInput | null;
}
